<template>
  <div class="container">
    <!-- <mt-header title="用户登录">
      <router-link to slot="left">
        <mt-button icon="back" @click.native="$router.back(-1)">返回</mt-button>
      </router-link>
    </mt-header>-->
    <div class="title">
      <span>名医智</span>|
      <span>登录</span>
    </div>
    <div class="form">
      <mt-field
        class="inputTxt"
        placeholder="请输入手机号"
        type="number"
        v-model="user.mobile"
        :state="usermobileStatus"
        @blur.native.capture="checkUsername"
      ></mt-field>
      <mt-field
        v-show="loginType == true"
        class="inputTxt"
        placeholder="请输入密码"
        type="password"
        v-model="user.password"
      ></mt-field>
      <!-- <div class="captchaBox" v-show="loginType==false">
        <mt-field placeholder="请输入验证码" type="tel" v-model="captcha"></mt-field>
        <span class="getcaptcha">获取验证码</span>
      </div>-->
      <div class="captchaBox" v-show="loginType == false">
        <mt-field
          placeholder="请输入验证码"
          type="tel"
          v-model="captcha"
        ></mt-field>
        <mt-button
          type="primary"
          :disabled="send"
          class="getcaptcha"
          @click="getCaptcha"
          >{{ send ? '验证码已发送' : '请获取验证码' }}</mt-button
        >
      </div>
      <p class="login">
        <router-link to="/register">还未注册？去注册</router-link>
        <span v-show="loginType == true" @click="changeLoginType"
          >手机验证码登录</span
        >
        <span v-show="loginType == false" @click="changeLoginType"
          >密码登录</span
        >
      </p>
      <div class="getBtn">
        <mt-button type="primary" class="btn" @click="login">登录</mt-button>
      </div>
      <!-- <mt-button type="primary" size="large" @click="login">登录</mt-button> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      usermobileStatus: '',
      captcha: '',
      user: {
        mobile: '',
        password: ''
      },
      loginType: true,
      send: false,
      disabled: false
    }
  },
  methods: {
    // 验证手机号
    checkUsername() {
      var usernameReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!usernameReg.test(this.user.mobile)) {
        this.$toast('手机号格式错误！')
        this.usermobileStatus = 'error'
        return this
      } else {
        this.usermobileStatus = 'success'
      }

      this.$http({
        url: '/live/liveUsers/getByMobile/' + this.user.mobile,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.usermobileStatus = 'success'

          console.log(data)
        } else {
          this.usermobileStatus = 'error'
          this.$toast('该用户不存在，请注册')
        }
      })
    },
    regCaptcha() {
      this.$http({
        url: `/live/liveUsers/check/${this.user.mobile}/${this.captcha}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
        } else {
          this.$messagebox.alert('验证码错误')
          this.captcha = ''
        }
      })
    },
    getCaptcha() {
      if (this.usermobileStatus === 'success') {
        this.$http({
          url: `/live/liveUsers/send/${this.user.mobile}`,
          method: 'get'
        }).then(({ data }) => {
          this.send = true
          this.$messagebox.alert('验证码已发送')
          setTimeout(() => {
            this.send = false
          }, 60000)
        })
      } else {
        this.$toast('手机号格式错误！')
      }
    },
    // 用户登录
    login() {
      this.$http({
        url: '/live/liveUsers/login',
        method: 'post',
        data: this.user
      }).then(({ data }) => {
        if (data && data.code === 0) {
          // 将用户名存储到Vuex,dispatch,分发
          this.$store.dispatch('change', data.user.mobile)
          // localStorage中
          localStorage.setItem('userInfo', JSON.stringify(data.user))
          window.localStorage.setItem('mobile', data.user.mobile)
          window.localStorage.setItem('userId', data.user.userId)
          this.$router.push('/personal')
          const routeData = this.$router.resolve({
            path: '/personal'
            // query: {
            //   cellName: cellName
            // }
          })
          window.open(routeData.href, '_blank')
        } else {
          this.user = {}
          this.$messagebox.alert('用户名或密码错误')
        }
      })
    },
    // 改变登录方式
    changeLoginType() {
      this.loginType = !this.loginType
    }
  }
}
</script>
<style lang="scss" scoped>
.captchaBox {
  position: relative;
  .getcaptcha {
    position: absolute;
    top: 2px;
    right: 2px;
  }
}
.title {
  padding: 2rem;
  font-size: 24px;
  color: #999;
  span {
    padding: 0 1rem;
    color: #333;
  }
  span:nth-child(2) {
    color: $theme-color;
    font-size: 18px;
  }
}
.getBtn {
  box-sizing: border-box;
  height: 55px;
  padding: 0 1rem;
  padding-bottom: 1rem;
  width: 100%;
  background-color: #fff;
}
.btn {
  // padding: 0 20px;
  width: 100%;
  height: 100%;
  font-size: $font-title;
}
.container {
  width: 100%;
  height: 100%;
  background: #fbfbfb;
  .form {
    border-top: 3rem solid #eee;
    padding: 0 1rem;
    .login {
      margin: 1rem;
      padding: 1rem 0;
      color: $theme-color;
      display: flex;
      justify-content: space-between;
      a {
        color: $theme-color;
      }
    }
  }
  .inputTxt {
    padding: 0;
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
  }

  .deal {
    text-align: center;
    margin: 2.4rem 0;
    .checkbox {
      position: relative;
      top: 2px;
    }
    a {
      color: $theme-color;
    }
  }
  /deep/ .mint-field-core {
    font-size: 1.4rem;
  }
  .btnBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .btn {
      padding: 0 20px;
      width: 76%;
    }
  }
  .context {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    p {
      text-align: center;
      margin: 0.4rem 0;
    }
  }
}
</style>
